import { api } from '@/shared/api/axios';
import { unwrapList } from '@/shared/api/unwrap';

export const deploymentsApi = {
  list: () => api.get('/deployments').then(unwrapList),
  get: (id) => api.get(`/deployments/${id}`).then((r) => r.data),
  create: (payload) => api.post('/deployments', payload).then((r) => r.data),
  update: (id, payload) => api.patch(`/deployments/${id}`, payload).then((r) => r.data),
  delete: (id) => api.delete(`/deployments/${id}`).then((r) => r.data),
};
